import { render } from "./MyRoster.vue?vue&type=template&id=7ed2f64b&scoped=true&ts=true"
import script from "./MyRoster.vue?vue&type=script&lang=ts"
export * from "./MyRoster.vue?vue&type=script&lang=ts"

import "./MyRoster.vue?vue&type=style&index=0&id=7ed2f64b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ed2f64b"]])

export default __exports__